import React from 'react';
import { useNavigate } from 'react-router-dom';
import Seo from '../../seo/Seo';
import { NAV_ACTIONS, LINKS } from '../website-header/navData';
import './NotFound.css';

// Any URL the router does not know. Marked noindex through the SEO registry
// ("*"), so a mistyped link never shows up in search results.
const SUGGESTIONS = [LINKS.modules, LINKS.pos, LINKS.store, LINKS.pricing, LINKS.contact];

export const NotFoundPage = () => {
  const navigate = useNavigate();
  const go = (href) => (e) => { e.preventDefault(); navigate(href); };
  return (
    <div className="nf-page">
      <Seo path="*" />
      <p className="nf-code">404</p>
      <h1 className="nf-title">This page does not exist.</h1>
      <p className="nf-sub">The link may be old or mistyped. Here are some places to go instead.</p>
      <nav className="nf-links" aria-label="Suggested pages">
        {SUGGESTIONS.map((l) => (
          <a key={l.href} href={l.href} onClick={go(l.href)}>{l.label}</a>
        ))}
      </nav>
      <a className="nf-home" href="/" onClick={go('/')}>Back to the home page</a>
      <p className="nf-meta">Or <a href={NAV_ACTIONS.primary.href} onClick={go(NAV_ACTIONS.primary.href)}>start a free trial</a>.</p>
    </div>
  );
};

export default NotFoundPage;
